"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.StyledInput = exports.PointerEventsReset = exports.IconWrapper = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _helpers = require("../helpers");
var _mixins = require("../mixins");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var barBackground = function barBackground(inputBackgroundHex) {
  return (0, _styledComponents.css)(["background:linear-gradient( to right,", ",", " 4px,", " 4px,", " 100% );"], function (props) {
    return props.theme.colors.warning;
  }, function (props) {
    return props.theme.colors.warning;
  }, inputBackgroundHex, inputBackgroundHex);
};

// The inner wrapper around an input field - will be used to position input icons & add the isRequired styles
var Wrapper = _styledComponents["default"].div.attrs(function (props) {
  var _props$w;
  return {
    w: (_props$w = props.w) !== null && _props$w !== void 0 ? _props$w : props.width
  };
}).withConfig({
  displayName: "InputParts__Wrapper",
  componentId: "sc-1y9ix9k-0"
})(["flex-grow:1;position:relative;width:100%;textarea{cursor:inherit;margin:0;box-sizing:border-box;-webkit-tap-highlight-color:transparent;resize:none;overflow:auto;}", ";"], function (props) {
  return props.w && (0, _styledComponents.css)(["width:", ";flex-grow:0;"], props.w);
});
exports.Wrapper = Wrapper;
var inputResetMixin = (0, _styledComponents.css)(["appearance:none;background-color:transparent;border:none;outline:0;padding:0;&::-moz-focus-inner{border:0;padding:0;}"]);
var inputDisabledStateMixin = (0, _styledComponents.css)(["color:", ";", " cursor:not-allowed;"], function (props) {
  return props.theme.colors.textSecondary;
}, function (props) {
  return props.variant === "border" && (0, _styledComponents.css)(["border-color:", ";"], function (props) {
    return props.theme.colors.border;
  });
});
var inputStatesMixin = (0, _styledComponents.css)(["&[disabled]{", "}", ";&:focus{outline:none;border-color:", ";background-color:", ";}", ";", ";", ";&[type=\"time\"],&[type=\"date\"]{height:", ";}"], inputDisabledStateMixin, function (props) {
  return props.disabled && (0, _styledComponents.css)(["", ""], inputDisabledStateMixin);
}, function (props) {
  return props.theme.colors.focus;
}, function (props) {
  return (0, _helpers.getColor)(props, "backgroundColor", "backgroundPrimary");
}, function (props) {
  return props.isFocus && (0, _styledComponents.css)(["outline:none;border-color:", ";background-color:", ";"], function (props) {
    return props.theme.colors.focus;
  }, function (props) {
    return (0, _helpers.getColor)(props, "backgroundColor", "backgroundPrimary");
  });
}, function (props) {
  return props.hasError && (0, _styledComponents.css)(["color:", ";border-color:", ";&:focus{border-color:", ";}", "::placeholder{color:", ";}"], props.theme.colors.error, props.theme.colors.error, props.theme.colors.error, props.isFocus && (0, _styledComponents.css)(["border-color:", ";"], props.theme.colors.error), props.theme.colors.error);
}, function (props) {
  return props.isHighlighted && (0, _styledComponents.css)(["background:", " !important;"], props.isRequired ? "linear-gradient(\n        to right,\n        ".concat(props.theme.colors.warning, ",\n        ").concat(props.theme.colors.warning, " 4px,\n        ").concat(props.theme.colors.success_1, " 4px,\n        ").concat(props.theme.colors.success_1, " 100%\n      )") : props.theme.colors.success_1);
}, function (props) {
  return props.theme.fields.height;
});

/* default styles used for an input */
var StyledInput = _styledComponents["default"].input.withConfig({
  displayName: "InputParts__StyledInput",
  componentId: "sc-1y9ix9k-1"
})(["", ";display:block;width:100%;border:1px solid ", ";background-color:", ";color:", ";font-size:", ";line-height:", ";padding:", " ", ";border-radius:", ";min-height:", ";&::placeholder{color:", ";}", ";", " ", ";", ";", ";", ";", ";"], inputResetMixin, function (props) {
  return props.theme.colors.inputBorder;
}, function (props) {
  return (0, _helpers.getColor)(props, "backgroundColor", "backgroundPrimary");
}, function (props) {
  return props.theme.colors.text;
}, function (props) {
  return props.theme.fields.fontSize;
}, function (props) {
  return props.theme.fields.lineHeight;
}, function (props) {
  return props.theme.fields.pV;
}, function (props) {
  return props.theme.fields.pH;
}, function (props) {
  return props.theme.borderRadius.base;
}, function (props) {
  return props.theme.fields.height;
}, function (props) {
  return props.theme.colors.textSecondary;
}, inputStatesMixin, function (props) {
  return props.isRequired && (0, _styledComponents.css)(["", ";"], barBackground((0, _helpers.getColor)(props, "backgroundColor", "backgroundPrimary")));
}, function (props) {
  return props.iconsCountLeft && (0, _styledComponents.css)(["padding-left:", ";"], props.theme.fields.iconSpace);
}, function (props) {
  return props.iconsCountRight && (0, _styledComponents.css)(["padding-right:calc( ", " * ", " );"], props.theme.fields.iconSpace, props.iconsCountRight === 2 ? 1.5 : 1);
}, function (props) {
  return props.variant === "filled" && (0, _styledComponents.css)(["background-color:", ";border-color:", ";&[disabled]{border-color:", ";}", " ", ""], (0, _helpers.getColor)(props, "backgroundColor", "inputBackground"), (0, _helpers.getColor)(props, "backgroundColor", "inputBackground"), (0, _helpers.getColor)(props, "backgroundColor", "inputBackground"), props.isRequired && (0, _styledComponents.css)(["", ";"], barBackground((0, _helpers.getColor)(props, "backgroundColor", "inputBackground"))), props.isFocus && (0, _styledComponents.css)(["border-color:", ";background-color:", ";", " ", ""], function (props) {
    return props.theme.colors.focus;
  }, function (props) {
    return (0, _helpers.getColor)(props, "backgroundColor", "backgroundPrimary");
  }, props.isRequired && (0, _styledComponents.css)(["", ";"], barBackground((0, _helpers.getColor)(props, "backgroundColor", "backgroundPrimary"))), props.hasError && (0, _styledComponents.css)(["border-color:", ";"], function (props) {
    return props.theme.colors.error;
  })));
}, function (props) {
  return props.variant === "activeFilled" && (0, _styledComponents.css)(["background-color:transparent;border-color:transparent;&[disabled]{border-color:transparent;}", " &:hover:not(:focus):not([disabled]){border-color:", ";background-color:", ";", "}"], props.isRequired && (0, _styledComponents.css)(["", ";"], barBackground("transparent")), (0, _helpers.getColor)(props, "backgroundColor", "inputBackground"), (0, _helpers.getColor)(props, "backgroundColor", "inputBackground"), props.isRequired && (0, _styledComponents.css)(["", ";"], barBackground((0, _helpers.getColor)(props, "backgroundColor", "inputBackground"))));
}, _mixins.gluedMixin);
exports.StyledInput = StyledInput;
var PointerEventsReset = _styledComponents["default"].div.withConfig({
  displayName: "InputParts__PointerEventsReset",
  componentId: "sc-1y9ix9k-2"
})(["pointer-events:initial;"]);

/* IconWrapper is meant to be placed inside a Wrapper */
exports.PointerEventsReset = PointerEventsReset;
var IconWrapper = _styledComponents["default"].div.attrs(function (props) {
  var _props$w2;
  return {
    w: (_props$w2 = props.w) !== null && _props$w2 !== void 0 ? _props$w2 : props.width
  };
}).withConfig({
  displayName: "InputParts__IconWrapper",
  componentId: "sc-1y9ix9k-3"
})(["position:absolute;top:0;height:100%;display:flex;align-items:center;justify-content:center;pointer-events:none;", ";", ";", ""], function (props) {
  return props.w && (0, _styledComponents.css)(["width:", ";"], props.w);
}, function (props) {
  return props.side && (0, _styledComponents.css)(["", ":0;"], props.side);
}, function (props) {
  return props.disabled && (0, _styledComponents.css)(["opacity:", ";", "{pointer-events:none;}"], function (props) {
    return props.theme.buttons.disableOpacity;
  }, PointerEventsReset);
});
exports.IconWrapper = IconWrapper;